import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import Text from 'shared/components/Text/Text';
import Button from 'shared/components/Button/Button';
import { useBreakpoints } from 'hooks/useWindowSize';
import { useOnboardingStep } from 'hooks/useOnboardingStep';
import { OnboardingStep } from 'modules/types/util';
import { OnboardingTPVContent, TPVVerifiedContainer } from './OnboardingTPV.styles';

const CheckmarkGraphic = React.lazy(() => import('shared/components/icons/CheckmarkGraphic'));

export function TPVVerified() {
  const { t } = useTranslation('translation', { keyPrefix: 'onboarding.tpv' });
  const screenSize = useBreakpoints();
  const { goToStep } = useOnboardingStep();

  return (
    <TPVVerifiedContainer>
      <Suspense fallback={<LoadingSpinner />}>
        <CheckmarkGraphic />
      </Suspense>
      <Text as="h1" $textAlign="center" $fontWeight={700} $margin="40px 0 8px">
        {t('verificationComplete')}
      </Text>
      <OnboardingTPVContent>
        <Text as="p" $margin="0 0 32px">
          {t('oneStepCloser')}
        </Text>
      </OnboardingTPVContent>
      <Button
        styleVariant="primary"
        label={t('next')}
        isFullWidth={screenSize === 'sm'}
        onClick={() => goToStep(OnboardingStep.AUTOPAY)}
      />
    </TPVVerifiedContainer>
  );
}

export default TPVVerified;
